import { HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Optional } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { WebStorage } from 'src/app/demo/components/auth/storage/web.storage';
import { GuardianDTO } from 'src/app/demo/model/GuardianDTO';
import { StaffDTO } from 'src/app/demo/model/StaffDTO';
import { StudentDTO } from 'src/app/demo/model/StudentDTO';
import { ChatService } from 'src/app/demo/service/chat.service';
import { LocalOperationService } from 'src/app/demo/service/localOperation.service';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { MemberService } from 'src/app/demo/service/member.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { UserNotificationService } from 'src/app/demo/service/userNotification.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { Common } from 'src/app/demo/utils/common';
import { profielBackgroundColor } from '../../constants/profielBackgroundColor';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddressDTO } from 'src/app/demo/model/AddressDTO';
import { ITEMS_PER_PAGE } from 'src/app/demo/constants/pagination.constants';
import { RoomDTO } from 'src/app/demo/model/RoomDTO';


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent {
  @ViewChild('guardianUploader') guardianUploader!: FileUpload;
  userData: any;
  isAdditionalAccount: boolean = false;
  isGuardian: boolean = false;
  activeStudentId!: number;

  guardianData: GuardianDTO = {};
  staffData: StaffDTO = {};
  staffAddress: AddressDTO = {};
  activeGuardianAllStudents: StudentDTO[] = [];
  activeStudent!: StudentDTO;
  withoutActiveStudent: StudentDTO[] = [];
  studentRelation?: string;
  staffRoomData: any = null;
  backgroundColors: string[] = [];
  showStudentImage = true;
  showStaffImage = true;
  staffForm!: FormGroup;
  addressForm!: FormGroup;
  clockIn: boolean = false;
  selectedCountry: string = "";
  isAddressFormValueChange: boolean = false;
  changedPhoneNumberForDatabase: string = '';
  selectedRoomIds!: any;
  showEditDialog = false;
  picture: any;
  
  // Guardian photo upload properties
  isUploadGuardianPhoto = false;
  uploadButton = true;
  showDeleteGuardianPhotoDialog = false;
  guardianPhotoDocument: any;
  
  countries: any = [
    { name: 'United States' },
    { name: 'India' },
    { name: 'Australia' },
    { name: 'Brazil' },
    { name: 'China' },
    { name: 'Egypt' },
    { name: 'France' },
    { name: 'Germany' },
    { name: 'Japan' },
    { name: 'Spain' },];
    updatedNumber!: string;
    search: any = {};
    activeRooms: String = "A";
    pageContext = {
      page: 0,
      previousPage: 0,
      itemsPerPage: 0,
      totalItems: 0,
      sort: "id,desc",
    };
      roomsList: RoomDTO[] = [];
    





  constructor(
    public layoutService: LayoutService,
    private lookupService: LookupService,
    private operationService: OperationService,
    private sanitizer: DomSanitizer,
    private storage: WebStorage,
    private cdr: ChangeDetectorRef,
    private localOperationService: LocalOperationService,
    private router: Router,
    private chatService: ChatService,
    private memberService: MemberService,
    public dialogService: DialogService,
    @Optional() public ref: DynamicDialogRef,
    private userNotificationService: UserNotificationService,
    private messageService: MessageService,
    private fb: FormBuilder,
  ) {
    this.backgroundColors = profielBackgroundColor;

  }

  ngOnInit(): void {
    this.userData = this.storage.getUserData();

    if (!this.userData) return;
    this.initializeForms();

    if (this.userData.refTable === 'Guardian') {
      this.isGuardian = true;
      this.queryGuardianData();
    } else if (this.userData.refTable === 'Staff') {
      this.isGuardian = false;
      this.queryStaffData();
    }

    this.lookupService.queryAccountCount({ 'ssoKey.equals': this.userData.ssoKey }).subscribe({
      next: (res: HttpResponse<any>) => {
        this.isAdditionalAccount = res.body === 2;
      },
      error: err => console.error('Error fetching account count:', err)
    });
  }

  loadRooms() {
    this.search["status.equals"] = this.activeRooms;
    this.search.size = 200;
    this.search.page = this.pageContext.page;
    this.search.sort = 'name,asc';
    this.lookupService
      .queryRooms(this.search)
      .subscribe((data: HttpResponse<RoomDTO[]>) => {
        let temp: RoomDTO[] = [];
        this.roomsList = data.body != undefined ? data.body : temp;
      });
  }

  async queryGuardianData() {
    const id = this.userData.refTableId;

    this.lookupService.getGuardianById(id).subscribe({
      next: async (res: HttpResponse<GuardianDTO>) => {
        this.guardianData = res.body!;

        if (this.guardianData.photoUuid) {
          this.lookupService.queryDocumentByPhotoUid(this.guardianData.photoUuid).subscribe({
            next: (resp: HttpResponse<Blob>) => {
              if (resp.body) {
                const url = this.createImgFromBuffer(resp.body);
                this.guardianData.profileimg = url;
                this.cdr.markForCheck();
              }
            },
            error: err => {
              console.error('Error fetching active student photo:', err);
            }
          });
        }
        this.activeGuardianAllStudents = this.guardianData.students ?? [];

        // Load active student from localStorage or first student
        const stored = localStorage.getItem('activeStudent');
        this.activeStudent = stored ? JSON.parse(stored) : (this.activeGuardianAllStudents[0] ?? {});
        localStorage.setItem('activeStudent', JSON.stringify(this.activeStudent));
        this.activeStudentId = this.activeStudent?.id!;

        // Fetch full active student data and room + photo
        if (this.activeStudentId) {
          try {
            const studentRes = await this.lookupService.getStudentById(this.activeStudentId).toPromise();
            this.activeStudent = { ...this.activeStudent, ...studentRes?.body };

            if (this.activeStudent.roomId) {
              const roomRes = await this.lookupService.getRoomById(this.activeStudent?.roomId).toPromise();
              this.activeStudent.roomName = roomRes?.body?.name ?? '-';
            } else {
              this.activeStudent.roomName = '-';
            }

            // Fetch active student photo by photoUuid (preferred)
            if (this.activeStudent.photoUuid) {
              this.lookupService.queryDocumentByPhotoUid(this.activeStudent?.photoUuid).subscribe({
                next: (resp: HttpResponse<Blob>) => {
                  if (resp.body) {
                    const url = this.createImgFromBuffer(resp.body);
                    this.activeStudent.profileimg = url;
                    this.cdr.markForCheck();
                  }
                },
                error: err => {
                  console.error('Error fetching active student photo:', err);
                }
              });
            }
          } catch (error) {
            console.error('Error loading active student full data:', error);
            this.activeStudent.roomName = '-';
          }
        }

        this.withoutActiveStudent = this.activeGuardianAllStudents.filter(student => student.id !== this.activeStudent?.id);

        // Load room and image for other students (use existing logic with slight improvement)
        for (const student of this.withoutActiveStudent) {
          if (student.id) {
            try {
              const studentRes = await this.lookupService.getStudentById(student.id).toPromise();
              student.roomId = studentRes?.body?.roomId;

              if (student.roomId) {
                const roomRes = await this.lookupService.getRoomById(student.roomId).toPromise();
                student.roomName = roomRes?.body?.name ?? '';
              }

              // Try fetching photo by photoUuid if available, else fallback to queryAllDocuments
              if (student.photoUuid) {
                this.lookupService.queryDocumentByPhotoUid(student.photoUuid).subscribe({
                  next: (resp: HttpResponse<Blob>) => {
                    if (resp.body) {
                      const url = this.createImgFromBuffer(resp.body);
                      student.profileimg = url;
                      this.cdr.markForCheck();
                    }
                  },
                  error: err => {
                    console.error('Error fetching student photo for id', student.id, err);
                    student.profileimg = undefined;
                  }
                });
              } else {
                this.lookupService.queryAllDocuments({
                  'docType.equals': 'PROFILE',
                  'refTableId.equals': student.id,
                  'refTable.equals': 'Student',
                }).subscribe((req: Blob) => {
                  if (req.size !== 0) {
                    const reader = new FileReader();
                    reader.onload = () => {
                      student.profileimg = this.sanitizer.bypassSecurityTrustResourceUrl('' + reader.result);
                      this.cdr.markForCheck();
                    };
                    reader.readAsDataURL(req);
                  } else {
                    student.profileimg = undefined;
                  }
                });
              }

            } catch (error) {
              console.error('Error loading student data:', error);
            }
          }
        }

        this.studentRelation = this.guardianData.relation ?? '';
        this.cdr.markForCheck();
      },
      error: err => {
        console.error('Error fetching guardian data:', err);
      }
    });
  }



  queryStaffData() {
    const id = this.userData.refTableId;
    this.lookupService.getStaffById(id).subscribe({
      next: (res: HttpResponse<StaffDTO>) => {
        this.staffData = res.body!;
        this.selectedRoomIds = this.staffData.rooms?.map(i => i?.id);

        // Step 1: Get actual address from DB by staff ID
        this.getAddressDetails(this.staffData.id).then(address => {
          if (address) {
            // Step 2: Patch addressForm using actual address object
            this.addressForm.patchValue({
              line: address.line || '',
              city: address.city || '',
              state: address.state || '',
              country: address.country || '',
              zipcode: address.zipcode || '',
              refTableId: this.staffData.id
            });
  
            // Optional: Format as string for display (if needed)
            const addressString = [
              address.line,
              address.city,
              address.state,
              address.country,
              address.zipcode
            ].filter(v => v).join(', ');
  
            // Example: store it as string in `staffData.address` for read-only view
            this.staffData.address = addressString;
          }
        });
  
        // Step 3: Handle room info
        const roomId = this.staffData.primaryRoomId;
        if (roomId) {
          this.lookupService.getRoomById(roomId).subscribe({
            next: (roomRes: HttpResponse<any>) => {
              this.staffRoomData = roomRes.body!;
              this.cdr.markForCheck();
            },
            error: roomErr => {
              console.error('Error fetching room data:', roomErr);
            }
          });
        }
  
        // Step 4: Fetch Staff profile image if photoUuid exists
        if (this.staffData.photoUuid) {
          this.lookupService.queryDocumentByPhotoUid(this.staffData.photoUuid).subscribe({
            next: (response: HttpResponse<Blob>) => {
              if (response.body) {
                const url = this.createImgFromBuffer(response.body);
                this.staffData.profileimg = url;
                this.cdr.markForCheck();
              }
            },
            error: err => {
              console.error('Error fetching staff photo:', err);
            }
          });
        }
  
        this.cdr.markForCheck();
      },
      error: err => {
        console.error('Error fetching staff data:', err);
      }
    });
  }
  

  async getAddressDetails(id: number | undefined): Promise<AddressDTO | undefined> {
    try {
      const response: HttpResponse<AddressDTO[]> | undefined =
        await this.lookupService
          .queryAddress({
            'schoolId.equals': this.userData.schoolId,
            'refTableId.equals': id,
            'refTable.equals': 'STAFF',
            size: ITEMS_PER_PAGE,
          })
          .toPromise();
  
      if (response) {
        const addresses: AddressDTO[] = response.body || [];
        const address: AddressDTO = addresses[0];
  
        if (address) {
          this.staffAddress = address;
          this.addressForm.patchValue(address); // patch here
  
          return address; // ✅ return object instead of string
        }
  
        throw new Error(`No Address found for staff with ID: ${id}`);
      }
      throw new Error(`No response received for staff with ID: ${id}`);
    } catch (error) {
      console.error(`Error retrieving Address with staff ID ${id}:`, error);
      return undefined;
    }
  }
  

  onSwitchProfile() {
    const targetRefTable = this.userData.refTable === 'Staff' ? 'Guardian' : 'Staff';
    localStorage.removeItem('logQueryParam');
    localStorage.setItem('logQueryParam', targetRefTable);
    localStorage.removeItem('activeStudent');
    window.location.href = '';
  }

  onViewProfile() {
    if (this.isGuardian && this.activeStudentId) {
      this.router.navigate([`/myschool/student/profile/${this.activeStudentId}/personal`]);
    } else {
      this.router.navigate([`/staff/staff-profile/${this.staffData.id}/basic`]);
    }
  }

  initializeForms() {
    this.staffForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: ['', [Validators.required, Validators.email]],
    });

    this.addressForm = this.fb.group({
      street: [''],
      city: [''],
      state: [''],
      zipcode: [''],
      country : [''],
      refTable: 'STAFF',
      refTableId: undefined,
      schoolId: this.userData.schoolId,
      status: ['A'],
      lastModified: [''],
      lastModifiedBy: [''],
    });
  }

  patchStaffData() {
    // Format full name
    const [firstName, lastName = ''] = this.staffData.name
      ? this.staffData.name.split(' ')
      : ['', ''];
  
    // Format phone number
    let formattedPhoneNumber: string | null = null;
    this.updatedNumber = this.staffData.phoneNumber ? this.staffData.phoneNumber : "";
    if (this.staffData.phoneNumber && this.staffData.phoneNumber.length === 10) {
      const raw = this.staffData.phoneNumber.replace(/[() -]/g, '');
      formattedPhoneNumber = `(${raw.substring(0, 3)}) ${raw.substring(3, 6)}-${raw.substring(6, 10)}`;
    }
  
    // Patch staff form
    this.staffForm.patchValue({
      firstName: firstName,
      lastName: lastName,
      phoneNumber: formattedPhoneNumber,
      email: this.staffData.email,
      designation: this.staffData.designation,
      employeeId: this.staffData.employeeId,
      hireDate: this.formatDateForInput(this.staffData.hireDate),
      dateOfBirth: this.formatDateForInput(this.staffData.dateOfBirth),
      cdaExpirationDate: this.formatDateForInput(this.staffData.cdaExpirationDate),
      cprExpirationDate: this.formatDateForInput(this.staffData.cprExpirationDate),
      lastPhysicalDate: this.formatDateForInput(this.staffData.lastPhysicalDate),
      jobTag: this.staffData.jobTag,
      clockInPin: this.staffData.clockInPin,
      profileStatus: this.staffData.profileStatus,
      inviteStatus: this.staffData.inviteStatus,
      allowedStudentRatio: this.staffData.allowedStudentRatio,
      schoolId: this.staffData.schoolId,
      primaryRoomId: this.staffData.primaryRoomId,
      rooms: this.selectedRoomIds,
      status: this.staffData.status,
      createdOn: this.staffData.createdOn,
      id: this.staffData.id,
      lastModified: this.staffData.lastModified,
      lastModifiedBy: this.staffData.lastModifiedBy
    });
  
    // Patch address form if available as object
    if (this.staffAddress) {
      this.addressForm.patchValue({
        line: this.staffAddress.line || '',
        city: this.staffAddress.city || '',
        state: this.staffAddress.state || '',
        country: this.staffAddress.country || '',
        zipcode: this.staffAddress.zipcode || '',
        refTableId: this.staffData.id
      });
    }
  
    this.cdr.detectChanges();
  }
  


  isStaffDataEmpty(): boolean {
    return !this.staffData || Object.keys(this.staffData).length === 0;
  }

  createImgFromBuffer(blob: Blob) {
    const url = URL.createObjectURL(blob);
    return url;
  }

  getInitials(roomName?: string): string {
    if (!roomName?.trim()) return '';
    const words = roomName.trim().split(/[-\s]+/);
    const firstLetter = words[0]?.[0]?.toUpperCase() || '';
    const secondLetter = words[1]?.[0]?.toUpperCase() || '';
    return `${firstLetter}${secondLetter}`.trim();
  }

  getInitialsStaff(roomName?: string): string {
    
    if (!roomName?.trim()) return '';
    const words = roomName.trim().split(/[-\s]+/);
    const firstLetter = words[0]?.[0]?.toUpperCase() || '';
    const secondLetter = words[1]?.[0]?.toUpperCase() || '';
    return `${firstLetter}${secondLetter}`.trim();
  }


  getBackgroundColor(roomId: any): any {
    if (!roomId) return this.backgroundColors[0];
    const index = (roomId - 1) % this.backgroundColors.length;
    return this.backgroundColors[index];
  }

  contiresSelectMethod(val: any) {
    this.selectedCountry = val;
  }


  async onSubmit() {
    const roomList = this.staffData.rooms;
    let isStaffData = true;
  
    const staffObj: StaffDTO = this.staffForm.value;
  
    if (!staffObj['firstName'] || !staffObj['lastName'] || !staffObj.email || !staffObj.phoneNumber) {
      isStaffData = false;
    }
  
    if ( !isStaffData) {
      if (!isStaffData) {
        if (!staffObj['firstName'] || !staffObj['lastName']) {
          this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'First and Last name must not be empty.' });
        }
        if (!staffObj.email) {
          this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Email must not be empty.' });
        }
        if (!staffObj.phoneNumber) {
          this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Phone Number must not be empty.' });
        }
      }
      return;
    }
  
    // Format and prepare final object
    const appendTime = 'T00:00:00Z';
    const payload: any = {
      ...this.staffForm.value,
    };
  
    if (this.staffData.clockInPin) {
      payload.address = this.addressForm.value;
    }
  
    payload.name = `${this.staffForm.value.firstName} ${this.staffForm.value.lastName}`;
  
    // Format phone number
    if (payload.phoneNumber) {
      if (payload.phoneNumber.length === 14) {
        payload.phoneNumber = payload.phoneNumber.replace(/[() -]/g, '');
      } else if (payload.phoneNumber.length > 0 && payload.phoneNumber.length < 14) {
        payload.phoneNumber = this.updatedNumber; // fallback cleaned version
      } else if (payload.phoneNumber.length === 0 || this.changedPhoneNumberForDatabase?.length === 0) {
        payload.phoneNumber = '';
      }
    }
  
    // Filter rooms
    const tags = this.roomsList.filter((item: RoomDTO) =>
      this.staffForm.value.rooms?.includes(item.id)
    );
    payload.rooms = tags;
  
    const isPrimaryRoom = tags.some(room => room.id === this.staffForm.get('primaryRoomId')?.value);
    payload.primaryRoomId = isPrimaryRoom ? this.staffForm.get('primaryRoomId')?.value : undefined;
  
    // Add default/hardcoded fields (if any, like from list)
    payload.photoUuid = this.staffData?.photoUuid;
    payload.hireDate = this.staffData?.hireDate;
    payload.cdaExpirationDate = this.staffData?.cdaExpirationDate;
    payload.cprExpirationDate = this.staffData?.cprExpirationDate;
    payload.lastPhysicalDate = this.staffData?.lastPhysicalDate;
    payload.jobTag = this.staffForm.get('jobTag')?.value;
    payload.createdOn = this.staffData?.createdOn;
    payload.status = 'A';
  
    // Finally close dialog and return payload
    this.ref.close(payload);
  }
  

  openDialog() {
    this.showEditDialog = true;
    this.patchStaffData(); // call patch function right when opening
  }
  
  // openDialog() {
  //   // Pass only the fields you want to show
  //   this.memberService.openDialog(['firstName', 'lastName', 'email', 'phoneNumber', 'addressInfo']);
  // }

  onCancel() {
    this.showEditDialog = false;
  }

  formatDateForInput(date: any): string {
    return date != undefined ? Common.momentTimeZoneDate(date) || '' : '';
    // return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
  }

  changeNumberMethod(val: any) {
    this.changedPhoneNumberForDatabase = val.target.value;
    this.changedPhoneNumberForDatabase =
      this.changedPhoneNumberForDatabase?.replace(/[() -]/g, '');
  }

      getAttenStatus(student: StaffDTO){
          if (student?.isSignedIn) {
              return 'Staff is signed in';
          } else if (student?.isAbsent) {
              return 'Staff is absent';
          }
          else if (student?.profileStatus == 'Upcoming') {
            return 'Staff is Upcomming';
          }
          else if (student?.profileStatus == 'I') {
            return 'Staff is Inactive';
          }
          return '';
      }

      // Guardian Photo Upload Methods
      showGuardianPhotoUploadDialog() {
        this.isUploadGuardianPhoto = true;
        // clear any previous files from the upload component so dialog doesn't show old preview
        setTimeout(() => {
          try { this.guardianUploader?.clear(); } catch (e) {}
        }, 50);
      }

      showGuardianDeletePhotoDialog() {
        this.showDeleteGuardianPhotoDialog = true;
      }

      closeGuardianDeletePhotoDialog() {
        this.showDeleteGuardianPhotoDialog = false;
      }

      closeGuardianPhotoUploadDialog() {
        this.isUploadGuardianPhoto = false;
        try { this.guardianUploader?.clear(); } catch (e) {}
      }

      onGuardianPhotoSelect(event: any) {
        // Handle both file input and PrimeNG FileUpload events
        let file: File;
        
        if (event.files && event.files.length > 0) {
          // PrimeNG FileUpload event
          file = event.files[0];
        } else if (event.target && event.target.files && event.target.files.length > 0) {
          // Regular file input event
          file = event.target.files[0];
        } else {
          return;
        }
        
        if (file) {
          this.uploadGuardianPhoto(file);
        }
      }

      uploadGuardianPhoto(file: File) {
        this.uploadButton = false;
        
        const fileExtension = file.name.split('.').pop();
        const document = {
          id: undefined,
          docType: 'PROFILE',
          docStatus: 'Personal Photo',
          fileName: file.name,
          contentType: fileExtension,
          fileUuid: undefined,
          folderUuid: undefined,
          refTable: 'Guardian',
          refTableId: this.userData.refTableId,
          schoolId: this.userData.schoolId,
          status: 'A',
          lastModified: undefined,
          lastModifiedBy: undefined,
          expiryDate: undefined,
        };

        this.operationService.createDocument(file, document).subscribe({
          next: async (response: any) => {
            this.messageService.add({
              severity: 'success',
              life: 3000,
              summary: 'Success',
              detail: 'Profile picture uploaded successfully.',
            });

            // Update guardian photoUuid
            const fileUuid = response.body?.fileUuid;
            if (fileUuid) {
              const updatedGuardian = {
                ...this.guardianData,
                photoUuid: fileUuid
              };
              
              this.operationService.updateGuardian(updatedGuardian).subscribe({
                next: () => {
                  this.guardianData.photoUuid = fileUuid;
                  // Refresh data to show new photo
                  this.queryGuardianData();

                  // Update localStorage cached user-profile so other parts of app that read it see the change
                  try {
                    const stored = localStorage.getItem('user-profile');
                    if (stored) {
                      const parsed = JSON.parse(stored);
                      // clear picture cache so topbar will re-query latest image
                      parsed.picture = undefined;
                      localStorage.setItem('user-profile', JSON.stringify(parsed));
                    }
                  } catch (e) {
                    // ignore JSON errors
                  }

                  // Notify topbar and other subscribers to re-fetch profile image
                  this.memberService.triggerTopbarRefresh();
                },
                error: (error) => {
                  console.error('Error updating guardian photoUuid:', error);
                }
              });
            }

            this.uploadButton = true;
                  // close and clear upload dialog
                  this.closeGuardianPhotoUploadDialog();
          },
          error: (error) => {
            this.messageService.add({
              severity: 'error',
              life: 3000,
              summary: 'Error',
              detail: 'Failed to upload profile picture.',
            });
            this.uploadButton = true;
          }
        });
      }

      async deleteGuardianPhoto() {
        if (!this.guardianData.photoUuid) {
          return;
        }

        try {
          // Find the document by photoUuid
          const response = await this.lookupService
            .queryDocuments({ 'fileUuid.equals': this.guardianData.photoUuid })
            .toPromise();
          
          const document = response?.body ? response.body[0] : null;
          
          if (document) {
            this.operationService.deleteDocument(document).subscribe({
              next: () => {
                // Update guardian to remove photoUuid
                const updatedGuardian = {
                  ...this.guardianData,
                  photoUuid: undefined
                };
                
                this.operationService.updateGuardian(updatedGuardian).subscribe({
                  next: () => {
                    this.guardianData.photoUuid = undefined;
                    this.guardianData.profileimg = undefined;
                    this.messageService.add({
                      severity: 'success',
                      life: 3000,
                      summary: 'Success',
                      detail: 'Profile picture deleted successfully.',
                    });
                    // Update localStorage cached user-profile so header clears without hard refresh
                    try {
                      const stored = localStorage.getItem('user-profile');
                      if (stored) {
                        const parsed = JSON.parse(stored);
                        parsed.picture = undefined;
                        localStorage.setItem('user-profile', JSON.stringify(parsed));
                      }
                    } catch (e) {}

                    // Inform topbar to re-query profile picture
                    this.memberService.triggerTopbarRefresh();
                    // Clear any remaining file preview in the upload dialog
                    try { this.guardianUploader?.clear(); } catch (e) {}
                    this.cdr.detectChanges();
                  },
                  error: (error) => {
                    console.error('Error updating guardian:', error);
                  }
                });
              },
              error: (error) => {
                this.messageService.add({
                  severity: 'error',
                  life: 3000,
                  summary: 'Error',
                  detail: 'Failed to delete profile picture.',
                });
              }
            });
          }
        } catch (error) {
          console.error('Error deleting guardian photo:', error);
        }
        
        this.closeGuardianDeletePhotoDialog();
      }

}